import { SurveyName } from '~/lib/constants/survey/SurveyName';

const sinceLastContactTrue = { 'since last contact': true };
const pastOneMonthTrue = { 'past 1 month': true };
const pastThreeMonthsTrue = { 'past 3 months': true };
const pastMonthTrue = { 'past month': true };
const lifetimeAndWasThisInLastThreeMonths = {
  lifetime: true,
  'was this in the last 3 months?': true,
};

export const SurveyNameToAlertQuestionsMap: Record<
  SurveyName,
  { [key: number | string]: boolean[] | string[] | Record<string, boolean> }
> = {
  [SurveyName.ADMISSIONS_INTAKE]: null,
  [SurveyName.ADMISSIONS_NPS]: null,
  [SurveyName.AIMS]: null,
  [SurveyName.ARFID]: null,
  [SurveyName.AUDIT]: null,
  [SurveyName.BAS]: null,
  [SurveyName.C_SSRS_LIFETIME]: {
    'c-ssrs-lr-1': pastOneMonthTrue,
    'c-ssrs-lr-2': pastOneMonthTrue,
    'c-ssrs-lr-3': pastOneMonthTrue,
    'c-ssrs-lr-4': pastOneMonthTrue,
    'c-ssrs-lr-5': pastOneMonthTrue,
    'c-ssrs-lr-aborted-attempt': pastThreeMonthsTrue,
    'c-ssrs-lr-actual-attempt': pastThreeMonthsTrue,
    'c-ssrs-lr-interrupted-attempt': pastThreeMonthsTrue,
    'c-ssrs-lr-preparatory-acts': pastThreeMonthsTrue,
  },
  [SurveyName.C_SSRS_LR_SCREENER]: null,
  [SurveyName.C_SSRS_RECENT_SCREENER]: {
    'c-ssrs-recent-short-1': pastMonthTrue,
    'c-ssrs-recent-short-2': pastMonthTrue,
    'c-ssrs-recent-short-3': pastMonthTrue,
    'c-ssrs-recent-short-4': pastMonthTrue,
    'c-ssrs-recent-short-5': pastMonthTrue,
    'c-ssrs-recent-short-6': lifetimeAndWasThisInLastThreeMonths,
  },
  [SurveyName.C_SSRS_SINCE_LAST_CONTACT]: {
    'c-ssrs-slc-1': sinceLastContactTrue,
    'c-ssrs-slc-2': sinceLastContactTrue,
    'c-ssrs-slc-3': sinceLastContactTrue,
    'c-ssrs-slc-4': sinceLastContactTrue,
    'c-ssrs-slc-5': sinceLastContactTrue,
    'c-ssrs-slc-aborted-attempt': sinceLastContactTrue,
    'c-ssrs-slc-actual-attempt': sinceLastContactTrue,
    'c-ssrs-slc-interrupted-attempt': sinceLastContactTrue,
    'c-ssrs-slc-preparatory-acts': sinceLastContactTrue,
  },
  [SurveyName.C_SSRS_SLC_SCREENER]: {
    'c-ssrs-slc-short-1': sinceLastContactTrue,
    'c-ssrs-slc-short-2': sinceLastContactTrue,
    'c-ssrs-slc-short-3': sinceLastContactTrue,
    'c-ssrs-slc-short-4': sinceLastContactTrue,
    'c-ssrs-slc-short-5': sinceLastContactTrue,
    'c-ssrs-slc-short-6': sinceLastContactTrue,
  },
  [SurveyName.CET]: null,
  [SurveyName.DISCHARGE_SUMMARY]: null,
  [SurveyName.DUDIT]: null,
  [SurveyName.EARLY_RESPONSE_CHECK_IN]: null,
  [SurveyName.EDE_Q]: null,
  [SurveyName.FNS]: null,
  [SurveyName.GAD7]: null,
  [SurveyName.LETHAL_MEANS]: null,
  [SurveyName.MENTOR_MATCHING]: null,
  [SurveyName.MP_INTAKE_ASSESSMENT]: null,
  [SurveyName.NIAAA_BSTAD]: null,
  [SurveyName.NIAS]: null,
  [SurveyName.NON_ARFID]: null,
  [SurveyName.NPS]: null,
  [SurveyName.PARDI_ARQ_PARENT]: null,
  [SurveyName.PARDI_ARQ_SELF]: null,
  [SurveyName.PATIENT_EXPERIENCE]: null,
  [SurveyName.PHQ8]: { 'phq9-9': ['1', '2', '3'] },
  [SurveyName.PHQ9]: { 'phq9-9': ['1', '2', '3'] },
  [SurveyName.POP]: null,
  [SurveyName.PSEA]: null,
  [SurveyName.QUALITY_OF_LIFE]: null,
  [SurveyName.SAFETY_PLAN]: null,
  [SurveyName.SAMPLE_SURVEY]: null,
  [SurveyName.TREATMENT_UPDATE]: null,
  [SurveyName.PCL5]: null,
};
